import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import ReactGA from 'react-ga';

import { getConfig } from 'Util/Config';
import { Text, Icon, Box } from 'Components/Base';
import { COLOR, FONT_SIZE } from 'Components/Theme';

const { lineContactLink, tcasterAppLink } = getConfig();

const Container = styled(({ alignItems, asNavLink, url, ...props }) =>
  asNavLink ? <NavLink {...props} /> : <Box {...props} />,
)`
  cursor: pointer;
  border-bottom: 1px solid ${COLOR.borderGrey};
  /* ${props => !props.url && `border-bottom: 1px solid ${COLOR.borderGrey};`} */
  padding: 16px;
  display: flex;
  align-items: baseline;
  color: ${props => (props.active ? COLOR.primary : COLOR.greyscale.grey1)};

  &:hover {
    color: ${COLOR.primary};
  }
  &:active {
    color: ${COLOR.dark};
  }
`;
const SideMenuItem = ({ title, icon, path, onClick, asNavLink, url }) => {
  const handleSideMenuOnClick = path => {
    if (tcasterAppLink === path) {
      try {
        ReactGA.event({ category: 'OTHER', action: 'TCASter App', label: 'Link to TCASter App' });
      } catch (err) {
        console.log('ga error:', err);
      }
    }
    if (lineContactLink === path) {
      try {
        ReactGA.event({ category: 'OTHER', action: 'Line Contact', label: 'Scan QR' });
      } catch (err) {
        console.log('ga error:', err);
      }
    }
    if (onClick) {
      onClick();
    }
  };
  const iconNode = icon ? (
    <Icon name={icon} iconStyle={{ marginRight: 12, fontSize: 20, marginBottom: 2 }} />
  ) : null;
  return url ? (
    <Container
      key={url}
      asNavLink={false}
      url={url}
      as="a"
      href={url}
      target="blank"
      rel="noopener noreferrer"
      onClick={() => {
        handleSideMenuOnClick(url);
      }}
    >
      {iconNode}
      <Text fontSize={FONT_SIZE.semilarge} color={'inherit'}>
        {title}
      </Text>
    </Container>
  ) : (
    <Container
      asNavLink={asNavLink}
      to={path}
      exact={['/'].includes(path)}
      key={path}
      onClick={onClick}
      activeStyle={{
        color: COLOR.primary,
      }}
    >
      {iconNode}
      <Text fontSize={FONT_SIZE.semilarge} color={'inherit'}>
        {title}
      </Text>
    </Container>
  );
};

SideMenuItem.propTypes = {
  icon: PropTypes.string,
  title: PropTypes.string,
  path: PropTypes.string,
  onClick: PropTypes.func,
};

export default SideMenuItem;
